import React, { useRef, useState, useEffect, useContext } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from '@tiptap/extension-link';
import Image from "@tiptap/extension-image";
import { ShopContext } from "./shopinfo";
import { AuthContext } from "./authcontext";
import { useAuth } from "./authcontext";

import '../tiptap.css'


export default function TiptapEditor({ fieldName, label }) {
    const { shopData, setShopData } = useContext(ShopContext);
    const inputRef = useRef();
    const [saving, setSaving] = useState(false);
    
    const editor = useEditor({
        extensions: [
                    StarterKit, 
                    Image, 
                    Link.configure({
                      openOnClick: false,
                      autolink: true,
                      linkOnPaste: true,
                    }),
                  ],
        content: shopData?.[fieldName] || "",
    });
    const {user} = useAuth();


    const addImage = (file) => {
        const reader = new FileReader();
        reader.onload = () => {
            const base64 = reader.result;
            editor?.chain().focus().setImage({ src: base64 }).run();
        };
        reader.readAsDataURL(file);
    };

    const handleImageUpload = () => {
        inputRef.current?.click();
    };

    const handleSave = async () => {
        if (!editor) return;
        setSaving(true);
      
        const updatedText = editor.getHTML();
      
        // Build form-encoded body like HTTPie example
        const params = new URLSearchParams();
        params.append("table", "pg_texte");
        params.append("field", "pg_id");
        params.append("value", shopData.pgid);  // record ID
        params.append("session_id", user.session_id );
        params.append("aml", shopData.pgid); 
       
        params.append(fieldName, updatedText);
      
        console.log("📦 Form-encoded body to send:", params.toString());
      
        try {
          const res = await fetch("/api-texte/editjson2", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: params.toString(),
          });
      
          const result = await res.json();
          console.log("✅ Server replied:", result);
      
          if (result.success !== false) {
            // update context so editor shows saved content immediately
            setShopData((prev) => ({ ...prev, [fieldName]: updatedText }));
          } else {
            console.warn("Backend reported failure:", result);
          }
        } catch (err) {
          console.error("Save failed:", err);
        } finally {
          setSaving(false);
        }
      };

    if (!editor) return null;

    return (
        <div className="contentContainer">
            <h4>{label}</h4>
            <div className="editorToolbar">
                <button onClick={() => editor.chain().focus().toggleBold().run()}><b>Fett</b></button>
                <button onClick={() => editor.chain().focus().toggleItalic().run()}><i>Kursiv</i></button>
                <button onClick={() => editor.chain().focus().toggleBlockquote().run()}>Blockzitat</button>
                <button onClick={handleImageUpload}>Bild einfügen</button>
                <button className='umbButton' onClick={handleSave} disabled={saving}>
                    <b>{saving ? "Speichern..." : "Speichern"}</b>
                </button>
                <input
                    className="editorInput"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={inputRef}
                    onChange={(e) => e.target.files[0] && addImage(e.target.files[0])}
                />
            </div>
            <div className="editorTextArea">
                <EditorContent editor={editor} />
            </div>
        </div>
    );
}